/**
 * 表单项目
 */

import React from 'react';

import Select from './select';
import ImagePicker from './image-picker';
import Toggle from './toggle';
import Text from './text';
import Slider from './slider';
import Textarea from './textarea';
import Styled from './styled';
import Checkbox from './checkbox';

const Form = Styled.Form;

const FormErrTipText = (props: { tip: string }) => {
  const { tip } = props;
  return <p className="error-tip text-warn">{tip}</p>;
};

const FormActions = (props: { label: string; onClick: any }) => {
  const { label, onClick } = props;

  return (
    <div className="form-actions">
      <button
        className="btn btn-primary btn-xl btn-primary-liner"
        onClick={onClick}
      >
        {label}
      </button>
    </div>
  );
};

export default {
  Form,
  FormActions,
  FormErrTipText,
  Text,
  Checkbox,
  Textarea,
  Select,
  ImagePicker,
  Toggle,
  Slider,
};
